import React, { ReactElement } from "react";
import {
  TradeInputsWithoutSymbol,
  ComponentProps,
  TradeType,
  ExtraTradeFields,
} from ".";
import { EquityTradeInputs } from "$gql/types.gen";

export type MarketBuyFields = Pick<EquityTradeInputs, "quantity"> &
  ExtraTradeFields;

const BuildOrder = (data: MarketBuyFields): TradeInputsWithoutSymbol => {
  return {
    duration: "day",
    quantity: data.quantity,
    side: "buy",
    type: "market",
    price: undefined,

    clientOrderId: data.clientOrderId,
    previewId: data.previewId,
  };
};

const Component = (props: ComponentProps<MarketBuyFields>): ReactElement => {
  return <> </>;
};

const MarketBuy: TradeType<MarketBuyFields> = {
  BuildOrder,
  Component,
};

export default MarketBuy;
